<template>
  <button
    class="btn mb-0"
    :class="getClasses(variant, color, size, fullWidth, active)"
    :style="btnStyle"
  >
    <slot />
  </button>
</template>

<script>
export default {
  name: "SoftButton",
  props: {
    color: { type: String, default: "success" },
    size: { type: String, default: "md" },
    variant: { type: String, default: "fill" },
    fullWidth: { type: Boolean, default: false },
    active: { type: Boolean, default: false },
    minWidth: { type: [Number, String], default: 100 },
  },
  computed: {
    btnStyle() {
      if (!this.minWidth) return null;
      const v = typeof this.minWidth === "number" ? `${this.minWidth}px` : this.minWidth;
      return { minWidth: v };
    },
  },
  methods: {
    getClasses: (variant, color, size, fullWidth, active) => {
      let colorValue, sizeValue, fullWidthValue, activeValue;

      if (variant === "gradient") colorValue = `bg-gradient-${color}`;
      else if (variant === "outline") colorValue = `btn-outline-${color}`;
      else colorValue = `btn-${color}`;

      sizeValue = size ? `btn-${size}` : null;
      fullWidthValue = fullWidth ? `w-100` : null;
      activeValue = active ? `active` : null;

      return `${colorValue} ${sizeValue} ${fullWidthValue} ${activeValue}`;
    },
  },
};
</script>
